// extracted by mini-css-extract-plugin
export var label = "_jk-2";
export var slideContainer = "_jk-0";
export var slider = "_jk-1";